module.exports = __webpack_public_path__ + "static/media/S__12165207.99da9682.jpg";